import React from 'react'
import './index.scss'
import classnames from 'classnames'
import LazyLoad from 'react-lazyload'

export interface IImageConfig {
  url: string
  deeplink?: string
  normallink?: string
  canScroll?: string
  spacing?: string
}

export interface IImageBoxProps {
  className?: string
  images: Array<IImageConfig | any>
}

const ImageBox = (props) => {
  const { config, clickTo, id, pid } = props
  const { className, images, imgType, canScroll, spacing } = config
  const classes = classnames(
    'lego_image_box',
    className,
    imgType,
    canScroll,
    spacing === 'true' ? 'spacing' : ''
  )

  return (
    <div className={classes} data-id={id} data-pid={pid}>
      {images &&
        images.map((item: IImageConfig, index: number) => {
          return (
            <div
              className={`lego_image_box_item ${
                index === images.length - 1 ? 'last' : ''
              }`}
              key={`lego_image_box_item_${index}`}
              onClick={() => clickTo('img', item.deeplink, item.normallink, id)}
            >
              <LazyLoad overflow={true} height={100} className="lazyImgBox">
                <img src={item.url} />
              </LazyLoad>
            </div>
          )
        })}
    </div>
  )
}

export default ImageBox
